var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9373 0.175537C15.1714 -0.058747 15.5524 -0.0583332 15.7869 0.175537C16.0208 0.409461 16.0213 0.788793 15.7879 1.02319L13.6111 3.20483C14.5476 4.45083 15.1043 5.99899 15.1043 7.67749L15.0945 8.06128C14.8945 11.9992 11.6374 15.1314 7.64923 15.1316L7.26544 15.1218C5.74167 15.0446 4.33892 14.5087 3.19122 13.6511L1.02423 15.824C0.790331 16.0582 0.411165 16.0584 0.176575 15.825C-0.0579824 15.5911 -0.0591195 15.211 0.174622 14.9763L2.28888 12.8552C1.07573 11.6 0.298419 9.92113 0.203918 8.06128L0.194153 7.67749C0.194153 3.56083 3.53196 0.223389 7.64923 0.223389L8.03302 0.233154C9.88602 0.327197 11.5604 1.09752 12.8143 2.30249L14.9373 0.175537ZM4.04962 12.7898C5.06769 13.5076 6.3087 13.9314 7.64923 13.9314C11.1036 13.9312 13.9038 11.1308 13.9041 7.67749C13.9041 6.3311 13.4767 5.08477 12.7527 4.06421L4.04962 12.7898ZM7.64923 1.42358C4.19453 1.42358 1.39435 4.22374 1.39435 7.67749C1.39451 9.35758 2.05813 10.882 3.13654 12.0056L11.9656 3.15405C10.843 2.0827 9.32372 1.42367 7.64923 1.42358Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.2accbbce232cefcf0fbc8f7544f195f2.svg";
export { ForwardRef as ReactComponent };